import { Input, InputProps } from 'antd';
import { genTestID } from '../../utils/utils';

interface TaggedTextInputOwnProps extends InputProps{
  tag:string
}

const TaggedTextInput = (props:TaggedTextInputOwnProps) => {
  const { tag } = props;

  return (
    <Input {...props} data-testid={genTestID('textInput', tag)} />
  );
};

export default TaggedTextInput;
